enum ActionTypes {
  LOAD_ENTERPRISE_SCAFFOLD_REQUEST = 'LOAD_ENTERPRISE_SCAFFOLD_REQUEST',
  LOAD_ENTERPRISE_SCAFFOLD_SUCCESS = 'LOAD_ENTERPRISE_SCAFFOLD_SUCCESS',
  LOAD_ENTERPRISE_SCAFFOLD_FAILURE = 'LOAD_ENTERPRISE_SCAFFOLD_FAILURE'
}

export default ActionTypes;
